import {db} from "../../firebase";

export const Invoices = db.collection('invoices')

export const getUserInvoices = (userId) => Invoices.where('userId', '==', userId)